import { get } from './shared';

const apiHost =
  process.env.NODE_ENV === 'production'
    ? process.env.GATSBY_MARKETTAP_PLATFORM_API_HOST
    : '';

export const fetch = async marketerSessionId => {
  const endpoint = `${apiHost}/api/v1/timeslots?marketer_session_id=${marketerSessionId}`;
  const json = await get(endpoint);
  return json;
};



// WEBPACK FOOTER //
// ./src/api/timeslots.js